import {
    CREATE_JOB_YARN_ISSUE,
    DELETE_JOB_YARN_ISSUE,
    GET_JOB_YARN_ISSUE,
    JOB_YARN_ISSUE_REQUEST,
    JOB_YARN_ISSUE_REQUEST_FAILURE,
    UPDATE_JOB_YARN_ISSUE,
    GET_JOB_YARN_ISSUES_PAGE,
    JOB_YARN_ISSUE_REQUEST_SUCCESS,
    GET_JOB_YARN_ISSUE_AVAILABLE_TRANSACTIONS,
    JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST,
    JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE
  } from "../types/job-yarn-issue-types";
  
  const initialState = {
    jobYarnIssue: [],
    jobYarnIssuesPage: [],
    availableTransactions: [],
    loading: false,
    error: null,
  };
  
  const jobYarnIssueReducer = (state = initialState, action) => {
    switch (action.type) {
      case JOB_YARN_ISSUE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_JOB_YARN_ISSUE: {
        return {
          ...state,
          jobYarnIssue: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_JOB_YARN_ISSUES_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          jobYarnIssuesPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_JOB_YARN_ISSUE:
        return {
          ...state,
          jobYarnIssue: [action.payload, ...state.jobYarnIssue],
          loading: false,
          error: null
        };
      case UPDATE_JOB_YARN_ISSUE:
        const jobYarnIssueData = state.jobYarnIssue.slice(0);
        const uIndex = jobYarnIssueData.findIndex((data) => data.id === action.payload.id);
        jobYarnIssueData.splice(uIndex, 1, { ...action.payload.data });
        
        return {
          ...state,
          jobYarnIssue: [ ...jobYarnIssueData ],
          loading: false,
          error: null
        };
      case DELETE_JOB_YARN_ISSUE:
        const jobYarnIssue = state.jobYarnIssue?.slice(0);
        const index = jobYarnIssue.findIndex((data) => data.id === action.id);
        if (index > -1) {
          jobYarnIssue.splice(index, 1);
        }
        return {
          ...state,
          jobYarnIssue: [...jobYarnIssue],
          loading: false,
          error: null
        }
      case JOB_YARN_ISSUE_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case JOB_YARN_ISSUE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      case JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_JOB_YARN_ISSUE_AVAILABLE_TRANSACTIONS: {
        return {
          ...state,
          availableTransactions: [ ...action.payload ],
          loading: false,
          error: null
        }
      }
      case JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default jobYarnIssueReducer;
  